/**
 * 准时签收率看板 - 每日 / 周度 / 月度
 */

// 总计列表头文案（每日 / 周度 / 月度三张表统一）
export const TOTAL_LABEL = '总计 Total Mês';

// 表格（Total 行 + 大区/州 行）
export function buildTableRows(tableRowList, dateColList, isZh) {
  const tableData = [];

  // Total 行
  const totalRow = tableRowList.find(r => r.rowType === 'TOTAL' && r.cells && r.cells.length > 0);
  if (totalRow) {
    tableData.push(buildTableRow(totalRow, 'Total', 'TOTAL', dateColList, isZh));
  }

  // 表格行：按 regionId 分 REGION 和 STATE
  const regionMap = {};
  tableRowList.forEach(row => {
    if (row.rowType === 'REGION' || row.rowType === 'STATE') {
      const rid = row.regionId;
      if (!regionMap[rid]) {
        regionMap[rid] = { regionRow: null, stateRows: [] };
      }
      if (row.rowType === 'REGION') {
        regionMap[rid].regionRow = row;
      } else {
        regionMap[rid].stateRows.push(row);
      }
    }
  });

  Object.values(regionMap).forEach(group => {
    if (!group.regionRow) return;
    const regionName = group.regionRow.regionName || '';
    const regionData = buildTableRow(group.regionRow, regionName, 'REGION', dateColList, isZh);
    regionData._rowKey = `region-${group.regionRow.regionId}`;
    regionData.children = group.stateRows.map(stateRow => {
      const stateData = buildTableRow(stateRow, stateRow.state || '', 'STATE', dateColList, isZh);
      stateData._rowKey = `state-${stateRow.regionId}-${stateRow.state}`;
      return stateData;
    });
    tableData.push(regionData);
  });

  return tableData;
}

// 列
export function buildTableRow(sourceRow, regionLabel, rowType, dateColList, isZh) {
  const row = {
    region: regionLabel,
    rowType: rowType
  };
  const cells = sourceRow.cells || [];
  dateColList.forEach((col, index) => {
    const cell = cells[index];
    if (!cell) return;
    const key = col.key;
    const isTotalCol = ['MONTH_TOTAL', 'RANGE_TOTAL'].includes(col.columnType);
    if (isTotalCol) {
      // 总计类列归入"总计"列
      row[key + '_total_qtd'] = formatNumber(cell.qtd, isZh);
      row[key + '_total_rate'] = cell.rate;
      row[key + '_total_rateFmt'] = formatPercent(cell.rate, isZh);
    } else {
      row[key + '_qtd'] = formatNumber(cell.qtd, isZh);
      row[key + '_rate'] = cell.rate;
      row[key + '_rateFmt'] = formatPercent(cell.rate, isZh);
    }
  });
  return row;
}

// 中文/葡语月份名称
export function getMonthLabel(monthNum) {
  const map = {
    1: '一月 Janeiro',
    2: '二月 Fevereiro',
    3: '三月 Março',
    4: '四月 Abril',
    5: '五月 Maio',
    6: '六月 Junho',
    7: '七月 Julho',
    8: '八月 Agosto',
    9: '九月 Setembro',
    10: '十月 Outubro',
    11: '十一月 Novembro',
    12: '十二月 Dezembro'
  };
  return map[monthNum] || String(monthNum);
}

// 千分位
export function formatNumber(val, isZh) {
  if (val === null || val === undefined || Number.isNaN(Number(val))) return '-';
  return Number(val).toLocaleString(isZh ? 'zh-CN' : 'pt-BR');
}

// 百分比小数点
export function formatPercent(val, isZh) {
  if (val === null || val === undefined || Number.isNaN(Number(val))) return '-';
  const percent = Number(val);
  return percent.toLocaleString(isZh ? 'zh-CN' : 'pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%';
}

// 准时签收率颜色样式（无效值不标红；大区名称行仅改变文字颜色）
export function rateClass(v, row) {
  if (v === null || v === undefined || v === '') return '';
  const n = Number(v);
  if (Number.isNaN(n)) return '';
  const isRegion = row && row.rowType === 'REGION';
  if (n >= 90) return isRegion ? 'rate-text-good' : 'rate-good';
  if (n >= 85) return isRegion ? 'rate-text-mid' : 'rate-mid';
  if (n >= 80) return isRegion ? 'rate-text-warning' : 'rate-warning';
  return isRegion ? 'rate-text-bad' : 'rate-bad';
}
